/*
 * 추천 카드 노출 집계 — 2026-08-03 신설
 *
 * 무엇을 세는가
 *   추천 카드가 화면에 3분의 1 이상 들어와 0.3초 이상 머물면 「노출 1회」로 센다.
 *   카드를 눌렀다면 머문 시간과 상관없이 노출로 센다 — 누른 순간은 확실히 본 것이다.
 *   한 페이지에서 같은 카드는 몇 번을 오르내려도 한 번만 센다.
 *
 * 왜 이렇게 하나
 *   예전에는 상세 페이지를 연 것만 세면서 화면 이름은 「노출현황」이라 부르고,
 *   숫자가 작아 보이니 화면에서 3을 곱해 부풀렸다. 이제 진짜 노출을 세므로
 *   곱할 필요가 없고, 노출 대비 클릭률이라는 지표도 만들 수 있다.
 *
 * 왜 슬라이드 안의 카드를 다 세지 않나
 *   추천 섹션은 슬라이더라 카드 아홉 장이 HTML 에는 다 들어 있지만
 *   실제로 보이는 것은 한두 장이다. 서버에서 그린 개수를 그냥 세면
 *   또 부풀리는 셈이 된다. 그래서 브라우저가 「진짜 보인 것」만 판정한다.
 *   Swiper 가 loop 를 쓸 때 만드는 복제 슬라이드도 같은 상품이므로 중복 제거된다.
 *
 * 보내는 방법
 *   모아 두었다가 페이지를 떠날 때(또는 5초마다) 한 번에 보낸다.
 *   카드가 아홉 장이어도 요청은 한 번이다.
 */
(function () {
	'use strict';

	// 아주 오래된 브라우저는 그냥 집계하지 않는다. 화면 동작에는 영향이 없다.
	if (!window.IntersectionObserver || !window.RC_STAT_URL) return;

	var URL_STAT = window.RC_STAT_URL;
	// 2026-08-03 감도 조정
	//  처음에는 「절반 이상 · 1초」로 잡았는데 실측 배수가 0.1~2.6 밖에 안 나왔다.
	//  클릭 한 번이 일어나려면 그 앞에 카드를 여러 장 봤어야 하므로 배수는 10 을 넘어야 정상이다.
	//  훑고 지나가는 손님이 대부분이라 1초가 너무 길었다. 광고 업계 기준(50% · 1초)은
	//  큰 배너 얘기이고, 목록 카드는 눈에 들어오는 순간 이미 본 것으로 친다.
	var RATIO = 0.35;     // 카드가 3분의 1 이상 보이면 인정
	var DWELL = 300;      // 그 상태로 0.3초
	var FLUSH = 5000;     // 5초마다 보낸다. 페이지를 떠나며 놓치는 것을 줄인다
	var MAX = 50;         // 한 번에 보내는 상한

	var counted = {};     // "가맹점|상품" → true. 이 페이지에서 이미 센 것
	var timers = {};      // 머문 시간을 재는 중인 것
	var pending = [];     // 아직 안 보낸 것

	function keyOf(el) {
		var vd = el.getAttribute('data-vd');
		var it = el.getAttribute('data-it');
		if (!vd || !it || it === '0') return '';
		return vd + '|' + it;
	}

	var io = new IntersectionObserver(function (entries) {
		for (var i = 0; i < entries.length; i++) {
			var e = entries[i];
			var key = keyOf(e.target);
			if (!key) { io.unobserve(e.target); continue; }

			if (counted[key]) { io.unobserve(e.target); continue; }

			if (e.isIntersecting && e.intersectionRatio >= RATIO) {
				if (timers[key]) continue;   // 이미 재고 있다
				timers[key] = setTimeout(makeCounter(key), DWELL);
			} else if (timers[key]) {
				clearTimeout(timers[key]);
				timers[key] = null;
			}
		}
	}, { threshold: [0, RATIO, 1] });

	// setTimeout 안에서 key 를 그대로 쓰면 반복문 변수가 바뀌어 엉킨다. 함수로 가둔다.
	function makeCounter(key) {
		return function () {
			timers[key] = null;
			if (counted[key]) return;
			counted[key] = true;
			pending.push(key);
			if (pending.length >= MAX) send();
		};
	}

	// 화면에 있는 카드를 관찰 대상에 넣는다.
	//  이미 센 카드는 건너뛴다 — 무한스크롤로 다시 그려져도 두 번 세지 않는다.
	//  선택자를 클래스가 아니라 두 속성으로 잡는 이유 — 판매채널은 .rc-item,
	//  요즘핫플은 .product-grid-item 으로 카드 클래스가 서로 다르다.
	//  「가맹점과 상품을 둘 다 달고 있는 것」이 곧 집계 대상이므로 이 편이 안전하다.
	function scan() {
		var list = document.querySelectorAll('[data-vd][data-it]');
		for (var i = 0; i < list.length; i++) {
			var key = keyOf(list[i]);
			if (!key || counted[key]) continue;
			io.observe(list[i]);
		}
	}

	// 무한스크롤이 카드를 덧붙인 뒤 부르라고 밖으로 내어 둔다.
	window.rcStatScan = scan;

	// 누른 카드는 1초를 못 채웠어도 노출로 센다. (2026-08-03 보완)
	//  목록을 훑다가 바로 누르는 손님이 많은데, 그러면 「본 적 없는데 눌렀다」는
	//  말이 안 되는 값이 남았다. 실제로 8월 첫 이틀 클릭 111 · 노출 56 이 그 결과다.
	//  누른 순간은 확실히 본 것이므로 여기서 채워 넣고 곧바로 보낸다.
	//  (페이지를 떠나면서 모아 보내는 평소 방식으로는 이 건이 유실된다)
	document.addEventListener('click', function (ev) {
		var el = ev.target;
		while (el && el !== document.body) {
			if (el.getAttribute && el.getAttribute('data-it')) break;
			el = el.parentNode;
		}
		if (!el || el === document.body) return;

		var key = keyOf(el);
		if (!key || counted[key]) return;
		if (timers[key]) { clearTimeout(timers[key]); timers[key] = null; }
		counted[key] = true;
		pending.push(key);
		send();
	}, true);

	function send() {
		if (!pending.length) return;
		var body = 'v=' + encodeURIComponent(pending.join(','));
		pending = [];

		// sendBeacon 은 페이지를 떠나는 중에도 확실히 나간다. 없으면 일반 요청으로.
		if (navigator.sendBeacon) {
			try {
				var blob = new Blob([body], { type: 'application/x-www-form-urlencoded' });
				if (navigator.sendBeacon(URL_STAT, blob)) return;
			} catch (err) { /* 아래로 내려가 일반 요청으로 보낸다 */ }
		}
		var xhr = new XMLHttpRequest();
		xhr.open('POST', URL_STAT, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.send(body);
	}

	// 탭을 가리거나 페이지를 떠날 때 보낸다. 모바일은 pagehide 가 더 확실하다.
	document.addEventListener('visibilitychange', function () {
		if (document.visibilityState === 'hidden') send();
	});
	window.addEventListener('pagehide', send);
	setInterval(send, FLUSH);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', scan);
	} else {
		scan();
	}
	// Swiper 가 복제 슬라이드를 만든 뒤에도 한 번 더 훑는다.
	window.addEventListener('load', scan);
})();
